<template>
  <v-app id="inspire" class="bodyPadding pricelistsScreen">
    <mo-header></mo-header>
    <v-content>
		<stock-head></stock-head>
		<stock-list></stock-list>
    </v-content>
  </v-app>
</template>

<script>

	import StockHead from './Header.vue';
	import StockList from './List.vue';
	import { mapGetters } from 'vuex';

	export default {
		data () {
			return {

			}
		},
		components: {
          StockHead,
          StockList
		},
		computed: {
			...mapGetters([
				'objAuthorize',
			])
		},
		created() {
			/*if( this.objAuthorize.privileges.indexOf('VIEW_STOCK') === -1 ) {
				this.$router.replace('/');
			}*/
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
